import Flatpickr from 'stimulus-flatpickr'

export default class extends Flatpickr {
  connect() {
    super.connect();
  }

  disconnect(){
    super.disconnect()
  }

}
